export default __webpack_public_path__ + "static/media/bgNew.9d238bdf.jpg";